import { dataAttribute } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAttribute = /*#__PURE__*/createIcon(dataAttribute)
export default IconAttribute
